<template>
    <b-row class="sell-card-footer">
        <b-col>
            <b-button
                class="w-100 py-3"
                :variant="card.button.color"
                @click="card.button.action"
            >
                {{ card.button.text }}
            </b-button>
        </b-col>
    </b-row>
</template>

<script>
    import './SellCardFooter.scss';

    export default {
        name: "SellCardFooter",

        props: {
            card: {
                type: Object,
                required: true,
            },
        },
    };
</script>
